// extracted by mini-css-extract-plugin
module.exports = {"modal":"UploadVersionModal_modal__2VBoM"};